import { useSyncExternalStore } from 'react';

/** Tailwind の md ブレークポイントと揃える */
const DESKTOP_QUERY = '(min-width: 48rem)';

const subscribe = (onChange: () => void) => {
  const mediaQueryList = window.matchMedia(DESKTOP_QUERY);
  mediaQueryList.addEventListener('change', onChange);
  return () => mediaQueryList.removeEventListener('change', onChange);
};

/**
 * md 以上の画面幅かどうか。
 * フォーム入力を持つ一覧は PC の表とスマホのカードを CSS の出し分けで両方描画すると
 * 同じフィールドが二重登録されるため、どちらか一方だけを描画するときに使う。
 */
export const useIsDesktop = () =>
  useSyncExternalStore(
    subscribe,
    () => window.matchMedia(DESKTOP_QUERY).matches,
    () => true,
  );
